<template>
  <validation-observer ref="EditDepartmentForm" #default="{ invalid }">
    <b-form @submit.prevent="formSubmitted">
      <b-row>
        <b-col md="12">
          <b-form-group label="Department Name" label-for="departmentName">
            <validation-provider #default="{ errors }" name="Department Name" rules="required">
              <b-form-input name="departmentName" placeholder="Department Name" v-model="department.departmentName" />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- submit and reset -->
        <b-col md="12" class="d-flex justify-content-between">
          <b-button type="submit" variant="primary" :disabled="invalid">
            Save
          </b-button>
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { mapActions } from "vuex";
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormGroup,
  BButton,
  BSpinner,
} from "bootstrap-vue";

export default {
  name: "AddDepartment",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    department: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions("departmentModule", ["getDepartmentListAction", "addDepartmentAction"]),

    formSubmitted() {
      this.$refs.EditDepartmentForm.validate().then(success => {
        if (success) {
          this.loading = true;
          let loader = this.$swal({
            title: 'Processing...',
            text: 'Please wait while the Department is being added',
            onOpen: () => {
              this.$swal.showLoading();
            },
            allowOutsideClick: () => !this.$swal.isLoading(),
            buttonsStyling: false,
            showConfirmButton: false,
          });

          this.addDepartmentAction(this.department).then(() => {
            loader.close();
            this.success();
            this.$bvModal.hide('modal-id'); 
            this.loading = false;
            this.getDepartmentListAction();
          }).catch(error => {
            loader.close();
            this.error(error.response.data);
            this.loading = false;
            this.getDepartmentListAction();
          });
        }
      });
    },

    success() {
      this.$swal({
        title: 'Department added!',
        text: 'You have successfully added the Department!',
        icon: 'success',
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$emit('DepartmentAdded');
        }
      });
    },

    error(data) {
      this.$swal('Error!', this.getErrorString(data) || 'Failed!', 'error');
    },

    getErrorString(data) {
      let msg = "<div><p>Cannot post your request due to the following errors:</p>";
      if (data.errors) {
        for (let prop in data.errors) {
          msg += `<p>${prop.replace("$.", "")}: ${data.errors[prop].toString().replace("$.", "")}</p>`;
        }
      } else if (data.message) {
        msg += `<p>${data.message}</p>`;
      }
      return msg + "</div>";
    }
  }
};
</script>
